import styled from "@emotion/styled";
import { format, parseISO } from "date-fns";
import { Tooltip } from "@mui/material";
import { Switch, Typography } from "@avenue-8/sidekick-ui";

const MONITORING_SINCE_FORMAT = "MMMM d, yyyy, h:mm a";

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

const StatusLabelWrapper = styled.span<{ $active: boolean }>`
  color: ${(p) =>
    p.$active ? p.theme.text.colors.brand : p.theme.text.colors.secondary};
`;

type RadarMonitoringToggleProps = {
  isMonitored: boolean;
  isMonitoredSince: string | null;
  isTogglePending?: boolean;
  onToggle: (nextValue: boolean) => void;
};

export const RadarMonitoringToggle = ({
  isMonitored,
  isMonitoredSince,
  isTogglePending = false,
  onToggle,
}: RadarMonitoringToggleProps) => {
  const control = (
    <Row>
      <Switch
        size="small"
        color="primary"
        checked={isMonitored}
        disabled={isTogglePending}
        onChange={(event) => onToggle(event.target.checked)}
        aria-label="Radar monitoring"
      />
      <StatusLabelWrapper $active={isMonitored}>
        <Typography variant="body2" sx={{ color: "inherit" }}>
          {isMonitored ? "Monitoring" : "Not monitored"}
        </Typography>
      </StatusLabelWrapper>
    </Row>
  );

  if (isMonitoredSince) {
    return (
      <Tooltip
        title={`Monitoring since ${format(parseISO(isMonitoredSince), MONITORING_SINCE_FORMAT)}`}
      >
        <div>{control}</div>
      </Tooltip>
    );
  }

  return control;
};
